import { GeneralFieldController } from "./general-field-controller";

export class PricePreviewTableController extends GeneralFieldController {}
